import { render, staticRenderFns } from "./cardAbnormalState.vue?vue&type=template&id=4072a109&"
import script from "./cardAbnormalState.vue?vue&type=script&lang=js&"
export * from "./cardAbnormalState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports